import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import { ThemeProvider } from 'styled-components';
import { Button } from '../../../../components';
import light from '../../../../assets/style/themes/dark';
import * as Message from '../../../../util/messageValidation';
import * as Ui from '../../styles';

const samePassword = 'Os campos de senha devem ter o mesmo valor';


export default function PasswordFormCard({ handleSubmit, running }) {
  const theme = light;
  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');
  const resStringAccess = 'Enviar';
  // initial values
  const initialValues = {
    password: '',
    rePassword: '',
  };

  function onSubmit() {
    // Verifica se a confirmação do password e o password são iguais
    if (password === rePassword) {
      handleSubmit(password);
    } else {
      toast.error(samePassword);
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Ui.Content>
        <h1>Esqueci minha senha</h1>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
        >
          <Form className="form">
            <Ui.InputField>
              <Field
                name="password"
                type="password"
                placeholder="Nova Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <ErrorMessage name="password">
                {(msg) => <span className="errorMessage">{msg}</span>}
              </ErrorMessage>
            </Ui.InputField>
            <Ui.InputField>
              <Field
                name="password"
                type="password"
                placeholder="Confirmar Senha"
                value={rePassword}
                onChange={(e) => setRePassword(e.target.value)}
              />
              <ErrorMessage name="rePassword">
                {(msg) => <span className="errorMessage">{msg}</span>}
              </ErrorMessage>
            </Ui.InputField>
            <div className="action">
              <Button title={resStringAccess} type="submit" loading={running} />
            </div>
          </Form>
        </Formik>
      </Ui.Content>
    </ThemeProvider>
  );
}
